import { createApp } from 'vue'
import { createPinia } from 'pinia'
import {
  init,
  browserTracingIntegration,
  replayIntegration,
  createSentryPiniaPlugin,
} from '@sentry/vue'
import '@/assets/css/main.css'

import App from './App.vue'
import router from './router'

// recharge la page si des nouvelles pages ont été déployées
// https://vite.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

const app = createApp(App)

// sentry
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN_VUE) {
  init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN_VUE,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_VERSION,
    integrations: [browserTracingIntegration({ router }), replayIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/vinisuivi\.codissea\.fr\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

// pinia
const pinia = createPinia()
pinia.use(createSentryPiniaPlugin())

app.use(pinia)
app.use(router)

app.mount('#app')
